/**
 * Alleen betaalmethoden die we aan klanten tonen (ingeschakeld in Stripe Checkout).
 * Bij wijzigingen in het Stripe-dashboard: pas deze lijst en `AcceptedPaymentBrands.tsx` aan.
 */

export type CustomerBrandId =
  | 'ideal'
  | 'bancontact'
  | 'visa'
  | 'mastercard'
  | 'apple-pay'
  | 'google-pay'
  | 'klarna'
  | 'link'
  | 'blik'
  | 'eps';

/** Volgorde: NL/EU eerst, daarna wallets en kaarten. */
export const CUSTOMER_BRAND_ORDER: CustomerBrandId[] = [
  'ideal',
  'bancontact',
  'visa',
  'mastercard',
  'apple-pay',
  'google-pay',
  'klarna',
  'link',
  'blik',
  'eps',
];

export const CUSTOMER_METHOD_COPY: Record<
  CustomerBrandId,
  { label: string; blurb: string }
> = {
  ideal: {
    label: 'iDEAL',
    blurb: 'Direct online betalen vanaf je Nederlandse bankrekening (inclusief Wero waar van toepassing).',
  },
  bancontact: {
    label: 'Bancontact',
    blurb: 'Populaire betaalwijze voor klanten in België.',
  },
  visa: {
    label: 'Visa',
    blurb: 'Wereldwijd gebruikte creditcard en debetkaart.',
  },
  mastercard: {
    label: 'Mastercard',
    blurb: 'Creditcard en debetkaart, breed geaccepteerd.',
  },
  'apple-pay': {
    label: 'Apple Pay',
    blurb: 'Snel afrekenen op iPhone, iPad en Mac waar Apple Pay beschikbaar is.',
  },
  'google-pay': {
    label: 'Google Pay',
    blurb: 'Betaling met je opgeslagen kaart in Google Wallet op ondersteunde apparaten.',
  },
  klarna: {
    label: 'Klarna',
    blurb: 'Betaalopties via Klarna waar Stripe en jouw regio dit toestaan.',
  },
  link: {
    label: 'Link',
    blurb: 'Stripe Link: eerder gebruikte gegevens opnieuw gebruiken voor een vlotte checkout.',
  },
  blik: {
    label: 'BLIK',
    blurb: 'Mobiele betaling voor klanten in Polen.',
  },
  eps: {
    label: 'EPS',
    blurb: 'Online bankoverschrijving voor klanten in Oostenrijk.',
  },
};
